/**
 * MoveItem - View component for individual move display and editing
 * Pure presentation component that delegates all logic to ViewModel
 */

import React from 'react';
import EditMode from './EditMode';
import DisplayMode from './DisplayMode';

export default function MoveItem({ index, moveObj, viewModel }) {
  const isEditingThisMove = viewModel.isEditing(index);

  const handleClick = () => {
    if (!isEditingThisMove) {
      viewModel.startEditingMove(index, moveObj.text || '');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      viewModel.saveEditedMove(index, viewModel.editValue);
    } else if (e.key === 'Escape') {
      viewModel.cancelEditing();
    }
  };

  return (
    <div
      className="move-item"
      onClick={handleClick}
      style={styles.moveItem}
    >
      {isEditingThisMove ? (
        <EditMode
          value={viewModel.editValue}
          onChange={viewModel.updateEditValue}
          onKeyDown={handleKeyDown}
          onSave={() => viewModel.saveEditedMove(index, viewModel.editValue)}
          onCancel={viewModel.cancelEditing}
        />
      ) : (
        <DisplayMode moveObj={moveObj} />
      )}
    </div>
  );
}

const styles = {
  moveItem: {
    cursor: 'pointer',
    textAlign: 'center',
    padding: '6px 4px',
    borderBottom: '1px solid #eee',
    fontFamily: 'monospace',
    fontSize: '1.1em',
    position: 'relative',
    background: 'transparent',
    borderRadius: 4
  }
};
